import { IMultiTree, ITree } from "../../types/siembra"
import { normalizeMultiTree, normalizeTree } from "../normalizer"

const fakeData = [
    {
        users: [
            {
                name: "Omar 3",
                lastName: "Arenas",
                date: "24/02/2015",
            },
            {
                name: "Omar 4",
                lastName: "Arenas",
                date: "24/02/2015",
            },
            {
                name: "Omar 5",
                lastName: "Arenas",
                date: "24/02/2015",
            },
        ],
        x: 900,
        y: 400,
    },
    {
        users: [
            {
                name: "Omar 3",
                lastName: "Arenas",
                date: "24/02/2015",
            },
            {
                name: "Omar 4",
                lastName: "Arenas",
                date: "24/02/2015",
            },
            {
                name: "Omar 5",
                lastName: "Arenas",
                date: "24/02/2015",
            },
        ],
        x: 900,
        y: 400,
    },
    {
        users: [
            {
                name: "Omar 3",
                lastName: "Arenas",
                date: "24/02/2015",
            },
            {
                name: "Omar 4",
                lastName: "Arenas",
                date: "24/02/2015",
            },
            {
                name: "Omar 5",
                lastName: "Arenas",
                date: "24/02/2015",
            },
        ],
        x: 900,
        y: 400,
    },
]

export const getTrees = async (): Promise<ITree[]> => {
    const data = await (await fetch("/eternal-users")).json() as any[]

    /*  const data = await new Promise<any[]>((res, rej) => {
         setTimeout(() => res(fakeTrees), 2000)
         setTimeout(() => rej([]), 3000)
     }) */

    if (data && data.length > 0) {
        return data.map(item => normalizeTree(item))
    }

    throw new Error("FAILING_FETCH")

}

export const sendTree = async (body: Pick<ITree, "x" | "y">): Promise<ITree> => {
    const data = await (await fetch("/store/eternal-users", {
        method: "POST",
        body: JSON.stringify(body)
    })).json() as any[]

    if (data) {
        return normalizeTree(data)
    }

    throw new Error("FAILING_FETCH")

}

export const getMultiTree = async (body: string): Promise<IMultiTree[]> => {
    const data = await (await fetch("/search/eternal-users?value=" + body, {
        method: "GET",
    })).json() as any[]

    if (data) {
        return data.map(item => normalizeMultiTree(item))
    }

    return []

}

export const getName = async (): Promise<string> => {
    const data = await (await fetch("/username-tapit", {
        method: "GET",
    })).json() as string

    if (data) {
        return data
    }

    throw new Error("FAILING_FETCH")

}

export const sendCdpData = async (body: object) => {

    const data = await (await fetch("/send-cdp", {
        method: "POST",
        body: JSON.stringify(body)
    })).json() as any[]
}